// v9 prototype styles for the analysis page (Basys-prototype-v9.html), as Tailwind classes.
// Theme colors come from the PR #11 tokens; literals are the values v9 itself hard-codes.

const BTN =
	'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border px-4 py-2 text-sm font-medium leading-5 transition-colors disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:flex-none';
export const BTN_PRIMARY = `${BTN} border-transparent bg-primary-500 text-white hover:bg-primary-600`;
export const BTN_SECONDARY = `${BTN} border-gray-300 bg-white text-primary-700 hover:bg-gray-50`;
// .btn-sm with the Back button's own padding (6px 12px).
export const BTN_BACK =
	'inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium leading-[18px] text-primary-700 hover:bg-gray-50 [&_svg]:h-3 [&_svg]:w-3';

const PILL =
	'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-1 text-xs font-medium leading-[1.3] [&_svg]:h-3 [&_svg]:w-3';
export const PILL_NEUTRAL = `${PILL} border-gray-200 bg-gray-100 text-gray-600`;
export const PILL_PRIMARY = `${PILL} border-primary-100 bg-primary-50 text-primary-700`;
export const PILL_SUCCESS = `${PILL} border-[#d1f19b] bg-[#e4f7c2] text-[#416211]`;
export const PILL_WARNING = `${PILL} border-sand-300 bg-sand-100 text-sand-900`;

// .status-row: full-width band with a round icon, a title and a detail line.
export const STATUS_ROW =
	'flex items-center justify-between gap-4 border-b border-gray-200 bg-white px-6 py-4';
export const STATUS_ICON =
	'flex h-9 w-9 flex-none items-center justify-center rounded-full bg-primary-100 text-primary-500 [&_svg]:h-5 [&_svg]:w-5';
export const STATUS_TITLE = 'text-base font-medium text-gray-900';
export const STATUS_DETAIL = 'text-sm text-gray-500';

export const CARD = 'rounded-lg border border-gray-200 bg-white';
export const CARD_TITLE = 'text-lg font-normal leading-normal text-gray-900';

// v9 fee-table column tints (literal in the prototype, not palette variables).
export const FEE_CUR_BG = 'bg-[#f5f3ff]';
export const FEE_NEW_BG = 'bg-[#eef2ff]';
// v9 "good" lime on navy.
export const LIME_TEXT = 'text-[#a2e63c]';
// .fee td.win in the BASYS block.
export const WIN_TEXT = 'text-[#5a8718] font-semibold';
